import { CIDService } from "./../../../../services/common/cid.service";
import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatSelect, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { IArea } from "src/app/interfaces/area";
import { ICity } from "src/app/interfaces/city";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { IHolding } from "src/app/interfaces/holding";
import { IProvince } from "src/app/interfaces/province";
import { IPhoneType } from "src/app/interfaces/phoneType";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { DiscountGroupService } from "src/app/services/http/business/discount-group/discount-group.service";
import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";

import { LevelInfoService } from "src/app/services/http/business/levelInfo/level-info.service";
import { CourseTypeService } from "src/app/services/http/business/course-type/course-type.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-entry-class-discount-group',
  templateUrl: './entry-class-discount-group.component.html',
  styleUrls: ['./entry-class-discount-group.component.css']
})
export class EntryClassDiscountGroupComponent implements OnInit {

  cityList: ICity;
  areaList: IArea;
  form: FormGroup;
  holdingList: IHolding[];
  provinceList: IProvince;
  phoneTypeList: IPhoneType;
  ab: any;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  companyEncryptCode: string;
  companyList: ICompany[];
  discountGroupTypeList = [];
  packageList = [];
  LevelList = [];
  PatternList = [];
  courseTypeList = [];

  constructor(
    private fb: FormBuilder,
    private discountGroupService: DiscountGroupService,
    private cidService: CIDService,
    private companyService: CompanyService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private courseTypeService: CourseTypeService,
    private staticValueService: StaticValueService,
    private dialogRef: MatDialogRef<EntryClassDiscountGroupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private levelInfoService: LevelInfoService,
  ) { }


  ngOnInit() {

    this.createForm();
    this.getDiscountGroupType();
    this.getCompanyList();
    this.loadLevels();
    if (this.data)
      this.loadPattern()

  }
  createForm() {
    console.log(this.data);

    this.form = this.fb.group({
      CompanyEncryptId: [this.data && this.data["CompanyEncryptId"] ? this.data["CompanyEncryptId"].toString() : null, !this.data ? Validators.required : null],
      // DiscountGroupTypeId: [this.data && this.data["DiscountGroupTypeId"] ? this.data["DiscountGroupTypeId"].toString() : null, !this.data ? Validators.required : null],
      Title: [this.data && this.data["Title"] ? this.data["Title"].toString() : null, Validators.required],
      DiscountPercent: [this.data && this.data["DiscountPercent"] ? this.data["DiscountPercent"].toString() : null, Validators.compose([Validators.required, Validators.min(1), Validators.max(100)])],
      Description: [this.data && this.data["Description"] ? this.data["Description"].toString() : ''],
      TimeFrom: [this.data && this.data["TimeFrom"] ? this.data["TimeFrom"].toString() : null, Validators.required],
      TimeTo: [this.data && this.data["TimeTo"] ? this.data["TimeTo"].toString() : null, Validators.required],
      IsNeedToCheck: [false],
      IsClassDiscount: [this.data && this.data.IsClassDiscount ? true : false, !this.data ? Validators.required : false],
      IsPreRegister: [this.data && this.data["IsPreRegister"] ? this.data["IsPreRegister"] : false],
      IsRegister: [this.data && this.data["IsRegister"] ? this.data["IsRegister"] : false],
      IsCourseDuring: [this.data && this.data["IsCourseDuring"] ? this.data["IsCourseDuring"] : false],




    });
    console.log(this.form);

  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getDiscountGroupType() {
    this.staticValueService.discountGroupType(false).subscribe(res => {
      console.log(res);
      this.discountGroupTypeList = res;
      console.log(this.discountGroupTypeList);
    })
  }

  setCID(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.loadPattern();
  }

  loadLevels() {
    this.levelInfoService.getAllLevelForTeacher().subscribe(res => {
      var result = [];

      res.DataList.forEach(
        (function (hash) {
          return function (a) {
            if (!hash[a.PackageName]) {
              hash[a.PackageName] = {
                PackageName: a.PackageName,
                activities: []
              };
              result.push(hash[a.PackageName]);
            }
            hash[a.PackageName].activities.push({
              Code: a.Code,
              ExpireDay: a.ExpireDay,
              Id: a.Id,
              IsActive: a.IsActive,
              IsGraduatedLevel: a.IsGraduatedLevel,
              Name: a.Name,
              PackageId: a.PackageId,
              PackageName: a.PackageName
            });
          };
        })(Object.create(null))
      );
      console.log(result);

      this.packageList = result;
      var enLevelLs = this.data.LevelInfoList.map(function (e) { return e.LevelInfoId });
      this.packageList.forEach(ac => {
        ac.activities.forEach(element => {
          //  var a = this.LevelList.indexOf(element.Id);
          if (this.data && this.data.LevelInfoList)
            if (enLevelLs.indexOf(element.Id) > -1) {
              element.selected = true;
            }
          // if (element.selected)
          //   xList.push(element.Id);
        });
      });

      // if (this.data && this.data.LevelInfoList) {
      //   for (let item of this.data.LevelInfoList) {
      //     if (item.LevelInfoId == aId) {
      //       let index = this.LevelList.indexOf(aId);
      //       if (index < 0) {
      //         this.LevelList.push(aId);
      //       }
      //       return true;
      //     }
      //   }
      // }
    });
  }

  selectAll(event, packageItem: any) {
    if (event.checked) {
      packageItem.activities.forEach(element => {
        element.selected = true;
      });
    }
    else {
      packageItem.activities.forEach(element => {
        element.selected = false;
      });
    }

  }

  loadPattern() {
    this.courseTypeService.list(0, 0, true, false, true).subscribe(res => {
      console.log(res);

      this.courseTypeList = res.DataList;
      this.checkPattern();
    })
  }


  // loadLevelsThatAssignedToTeacher() {
  //   this.levelInfoService
  //     .ListLevelPerson(this.data.NationalCode)
  //     .subscribe(res => {
  //       this.teacherLevels = res;
  //       this.LevelList = res.LevelList;
  //     });
  // }

  check(aId: number) {
    if (this.data && this.data.LevelInfoList) {
      for (let item of this.data.LevelInfoList) {
        if (item.LevelInfoId == aId) {
          let index = this.LevelList.indexOf(aId);
          if (index < 0) {
            this.LevelList.push(aId);
          }
          return true;
        }
      }
    }
  }

  checkList(event, level) {
    // if (this.LevelList == null) {
    //   this.LevelList = new Array();
    // }
    // if (event.checked) {
    //   this.LevelList.push(id);
    // }
    // if (!event.checked) {
    //   let index = this.LevelList.indexOf(id);
    //   if (index > -1) {
    //     this.LevelList.splice(index, 1);
    //   }
    // }
    level.selected = event.checked
  }

  // checkList(event, id) {
  //   if (this.LevelList == null) {
  //     this.LevelList = new Array();
  //   }
  //   if (event.checked) {
  //     this.LevelList.push(id);
  //   }
  //   if (!event.checked) {
  //     let index = this.LevelList.indexOf(id);
  //     if (index > -1) {
  //       this.LevelList.splice(index, 1);
  //     }
  //   }
  //   console.log(this.LevelList);
  // }

  checkPattern() {
    var xData = this.data;
    if (xData && xData.CoursePatternList) {
      var xCoursePatternList = xData.CoursePatternList.map(function (e) { return e.CoursePatternId });
      this.courseTypeList.forEach(function (type) {
        type.CoursePatternList.forEach(function (pattern) {
          if (xCoursePatternList.indexOf(pattern.Id) >= 0)
            pattern.selected = true;
          else
            pattern.selected = false;
        })
      });
    }
    //   for (let item of this.data.CoursePatternList) {
    //     if (item.CoursePatternId == aId) {
    //       let index = this.PatternList.indexOf(aId);
    //       if (index < 0) {
    //         this.PatternList.push(aId);
    //       }
    //       return true;
    //     }
    //   }
  }
  checkListPattern(event, pattern) {
    pattern.selected = event.checked
  }
  // checkListPattern(event, id) {
  //   if (this.PatternList == null) {
  //     this.PatternList = new Array();
  //   }
  //   if (event.checked) {
  //     this.PatternList.push(id);
  //   }
  //   if (!event.checked) {
  //     let index = this.PatternList.indexOf(id);
  //     if (index > -1) {
  //       this.PatternList = this.PatternList.splice(index, 1);
  //     }
  //   }
  //   console.log(this.PatternList);

  // }

  submit(form: any) {

    let levels = [];
    this.packageList.forEach(ac => {
      ac.activities.forEach(element => {
        if (element.selected) {
          levels.push({ LevelInfoId: element.Id });
        }
      });
    });
    // this.LevelList.forEach(function (item) {
    //   levels.push({ LevelInfoId: item });
    // });
    let patterns = [];
    this.courseTypeList.forEach(function (type) {
      type.CoursePatternList.forEach(function (pattern) {
        if (pattern.selected)
          patterns.push({ CoursePatternId: pattern.Id });
      })
    });
    // this.PatternList.forEach(function (item) {
    //   patterns.push({ CoursePatternId: item });
    // });
    let data = {
      TimeFrom: form.TimeFrom,
      TimeTo: form.TimeTo,
      CoursePatternList: patterns,
      LevelInfoList: levels,
      Title: form.Title,
      DiscountPercent: form.DiscountPercent,
      IsNeedToCheck: form.IsNeedToCheck,
      IsClassDiscount: form.IsClassDiscount,
      IsPreRegister: form.IsPreRegister,
      IsRegister: form.IsRegister,
      IsCourseDuring: form.IsCourseDuring,
      Description: form.Description,
      Id: this.data && this.data.Id ? this.data.Id : 0
    };
    if (!this.data) {
      this.discountGroupService.addClassPersonDiscount(data).subscribe(() => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.saveClassDiscountGroup"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.dialogRef.close();
      },
        error => {

          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        })
    }
    else {
      this.discountGroupService.editClassPersonDiscount(data).subscribe(() => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.saveClassDiscountGroup"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.dialogRef.close();
      },
        error => {

          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        })
    }

  }

  onNoClick() {
    this.dialogRef.close();
  }



}
